import './SpamTestResult.css';

import React, { useMemo } from 'react';
import checkIcon from '../../assets/images/check.svg';
import errorIcon from '../../assets/images/error.svg';
import { SpamPreviewTestStatus, SpamResultStatus, type SpamResult } from '../../types/spam-preview';
import { ClickLoadingIndicator } from '..';

type ErrorStates = SpamPreviewTestStatus.ABANDONED | SpamPreviewTestStatus.ERROR | false;
type SpamProviderProps = {
  result: SpamResult;
  errorState: ErrorStates;
};

export const SpamTestResult: React.FC<SpamProviderProps> = ({ result, errorState = false }) => {
  const resultText: SpamResultStatus = useMemo(
    () => getResultText(result, errorState),
    [result, errorState],
  );
  const formatStatusLabel = (status: string) => {
    if (!status) return '';
    const lower = status.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };
  const statusLabel = formatStatusLabel(resultText);
  const icon =
    resultText === SpamResultStatus.PASS ? (
      <img
        src={checkIcon}
        alt="passed"
        className="spam-icon-pass"
      />
    ) : resultText === SpamResultStatus.FAIL ? (
      <img
        src={errorIcon}
        alt="failed"
        className="spam-icon-error"
      />
    ) : null;

  return (
    <li
      key={result.applicationName}
      className="mail-provider-list-item spam-result-item"
    >
      <span className="spam-result-label">{result.applicationLongName}:</span>
      <span className={`spam-result-status ${resultText.toLowerCase()}`}>{statusLabel}</span>
      {icon}
      {!errorState && resultText === SpamResultStatus.PENDING && (
        <div className="spam-row-spinner w-8 pl-2">
          <ClickLoadingIndicator
            isLoading={true}
            type="thumb"
          />
        </div>
      )}
      {!result.isPassed && result.failureDescription && (
        <span className="error-description">{result.failureDescription}</span>
      )}
    </li>
  );
};

const getResultText = (result: SpamResult, errorState: ErrorStates): SpamResultStatus => {
  const abandoned = errorState === SpamPreviewTestStatus.ABANDONED;
  const error = errorState === SpamPreviewTestStatus.ERROR;
  if (error) {
    return SpamResultStatus.NA;
  } else if (result.isPassed === false && result.status === 0) {
    return abandoned ? SpamResultStatus.ABANDONED : SpamResultStatus.PENDING;
  } else {
    return result.isPassed ? SpamResultStatus.PASS : SpamResultStatus.FAIL;
  }
};
